import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { IBlock } from "../../../framework/src/IBlock";
// Customizable Area Start
import React from "react";
import {
  PaymentsIcon,
  LinkIcon,
  OldPhoneIcon,
  TodayIcon,
  WalletIcon,
  StoreIcon,
} from "../../../components/src/customComponents/PaymentModalAssets";
import { Message } from "../../../framework/src/Message";
import { getStorageData } from "../../../framework/src/Utilities";
import { IOrder } from "../../AljabrStore/src/AljabrStore2Controller.web";
import { makeApiMessage } from "../../../components/src/common";

export const configJSON = require("./config");

export interface PaymentTransactionData {
  id: string;
  attributes: {
    store_management: {
      data: {
        id: string;
        type: string;
        attributes: {
          store_name: string;
          use_raw_printing_receipt: boolean;
        };
      };
    };
  };
}

export interface IPaymentMethod {
  id: number;
  name: string;
  active: boolean;
  enableSecond?: boolean;
  attributes: {
    icon: {
      data: {
        attributes: {
          image: string;
        };
      };
    };
  };
}

export interface IPromoCode {
  saved_amount: number;
  product_name: string;
  discount: string;
  expiry_date: null | string;
  min_order_amount: null | string;
  promo_expires: boolean;
  promo_code: string;
  description: string;
  id: number;
  currency: string;
  bogo_enabled?: boolean;
}

export interface ISidebarItems {
  key: number;
  title: string;
  apiKey?: string;
  secondKey: number;
  icon: React.ReactNode;
  enableSecond?: boolean;
}

export interface ILateDeliveryConfig {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    hours: number;
    color: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
  };
}

export const initialSideBarItems: Array<ISidebarItems> = [
  {
    key: 2,
    secondKey: 1,
    title: "Cash",
    apiKey: "cash",
    enableSecond: true,
    icon: <PaymentsIcon />,
  },
  {
    title: "POS Machine",
    icon: <OldPhoneIcon />,
    key: 3,
    secondKey: 3,
  },
  {
    title: "Payment Link",
    icon: <LinkIcon />,
    key: 5,
    secondKey: 4,
  },
  {
    title: "Pay Later",
    icon: <TodayIcon />,
    key: 6,
    secondKey: 5,
    enableSecond: true,
  },
  {
    title: "Store Pay",
    icon: <StoreIcon />,
    key: 7,
    secondKey: 6,
  },
  {
    key: 4,
    secondKey: 2,
    title: "Wallets",
    apiKey: "wallets",
    enableSecond: true,
    icon: <WalletIcon />,
  },
];

// Customizable Area End

export interface Props {
  // Customizable Area Start
  open: boolean;
  handleClose: () => void;
  totalItems: number | undefined;
  taxPercentage: number | undefined | string | null;
  customerId: string;
  order?: IOrder;
  cleaningOrder?: boolean;
  onPromoCodeApply: () => void;
  onPaymentDone: (orderTransantions?: PaymentTransactionData[]) => void;
  paymentClicked: boolean;
  fromUnpaid?: boolean;
  isMainPayment?: boolean;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  activeTab: number | string;
  totalAmount: string;
  points: number;
  skipRedeemPoints: boolean;
  isRedeemAllPoints: boolean;
  isUsed: boolean;
  currency: string;
  successMessage: string;
  errorMessage: string;
  errorSnackbarOpen: boolean;
  showOtpScreen: boolean;
  otpToken: string;
  otpValue: string;
  paymentMethods: IPaymentMethod[];
  walletBalance: number;
  secondPaymentEnabled: boolean;
  customPaymentAmount: string;
  remainBalance: number;
  paymentMathod: string;
  selectedSecondPaymentMethod: string;
  loading: boolean;
  isQitafOtpComplete: boolean;
  isRemainingBalanceLoading: boolean;
  isPayButtonClicked: boolean;
  lateDeliveryConfigs: ILateDeliveryConfig[];
  selectedLateDeliveryConfig: string | null;
  otpAttemptRights: boolean;
  isButtonDisabled: boolean;
  qitaf_otp_time: boolean;
  walletVerifyOpen: boolean;
  walletVerifyChannel: "qr" | "otp" | null;
  walletVerifyOtpCode: string;
  walletVerifyToken: string;
  walletVerifyMaskedPhone: string;
  walletVerifyExpiresAt: string;
  walletVerifySending: boolean;
  walletVerifyVerifying: boolean;
  walletVerifyOtpSent: boolean;
  walletVerified: boolean;
  walletVerifyError: string;
  walletVerifyWalletType: string;
  walletVerifyAmount: number;
  // Customizable Area End
}
interface SS {
  id: any;
}

export default class GoldenPointPaymentController extends BlockComponent<
  Props,
  S,
  SS
> {
  constructor(props: Props) {
    // Customizable Area Start
    super(props);
    this.makePayment = this.makePayment.bind(this);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceErrorMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];
    // Customizable Area End

    this.state = {
      activeTab: 0,
      totalAmount: "",
      currency: "",
      points: 0,
      isRedeemAllPoints: false,
      isUsed: false,
      errorMessage: "",
      errorSnackbarOpen: false,
      showOtpScreen: false,
      otpToken: "",
      otpValue: "",
      paymentMethods: [],
      secondPaymentEnabled: false,
      selectedSecondPaymentMethod: "",
      walletBalance: 0,
      customPaymentAmount: "",
      skipRedeemPoints: false,
      walletVerifyOpen: false,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyMaskedPhone: "",
      walletVerifyExpiresAt: "",
      walletVerifySending: false,
      walletVerifyVerifying: false,
      walletVerifyOtpSent: false,
      walletVerified: false,
      walletVerifyError: "",
      walletVerifyWalletType: "",
      walletVerifyAmount: 0,
      remainBalance: 0,
      paymentMathod: "",
      successMessage: "",
      loading: false,
      isQitafOtpComplete: false,
      otpAttemptRights: false,
      isButtonDisabled: false,
      qitaf_otp_time: false,
      isRemainingBalanceLoading: false,
      isPayButtonClicked: false,
      lateDeliveryConfigs: [],
      selectedLateDeliveryConfig: null,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  // Customizable Area Start

  getRewardsCallId: string = "";
  // getWalletBalanceCallId: string = "";
  getRemainBalanceCallId: string = "";
  getPaymentMethodsCallId: string = "";
  makePaymentCallId: string = "";
  getOrderDetailsCallId: string ="";
  sendOtpCallId: string = "";
  sendWalletVerifyOtpCallId: string = "";
  verifyWalletCallId: string = "";
  headerContentType = { "Content-Type": "application/json" };

  async getHeaders() {
    const token = await getStorageData("token");
    return {
      "Content-Type": "application/json",
      token,
    };
  }

  getRewards = () => {
    const { customerId } = this.props;

    const message = makeApiMessage({
      method: "GET",
      url: configJSON.getTotalRewardPointsEndpoint + customerId,
    });

    this.getRewardsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  // getWalletBalance = () => {
  //   const { customerId } = this.props;

  //   const message = makeApiMessage({
  //     url: configJSON.getWalletBalanceEndpoint + customerId,
  //     method: "GET",
  //   });

  //   this.getWalletBalanceCallId = message.messageId;
  //   runEngine.sendMessage(message.id, message);
  // }

  async getRemainBalance() {
    if (!this.props.order) return;
    this.setState({ isRemainingBalanceLoading: true });
    const { order, cleaningOrder } = this.props;
    const orderId = Array.isArray(this.props.order)
      ? this.props.order[0].id
      : this.props.order?.id;

    const headers = await this.getHeaders();
    const isEditKey = this.props.fromUnpaid ? "&edit_order=true" : "";
    const cleaningOrderKeys = cleaningOrder ? "&unpaid_amount=true" : "";

    const endpoint = cleaningOrder
      ? configJSON.getRemainingBalanceEndPointForCleaningOrder
      : configJSON.getRemainingBalanceEndPoint;

    const message = makeApiMessage({
      url: endpoint + orderId + isEditKey,
      headers: headers,
      method: "GET",
    });
    this.getRemainBalanceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  async getPaymentMethods() {
    const headers = await this.getHeaders();

    const message = makeApiMessage({
      url: configJSON.paymentMethodsEndpoint,
      headers: JSON.stringify(headers),
      method: "GET",
    });

    this.getPaymentMethodsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  // async makePayment() {
  makePayment = async (otp: string, orders?: any) => {
    const currentOrder = this.props?.order || orders;
    if (!currentOrder) return;
    if (
      !this.state.paymentMethods.some(
        (paymentMethod: IPaymentMethod) =>
          paymentMethod.id === this.state.activeTab
      )
    )
      return;
    const { fromUnpaid, customerId } = this.props || {};
    const order = currentOrder;
    const {
      activeTab,
      remainBalance,
      customPaymentAmount,
      secondPaymentEnabled,
      selectedLateDeliveryConfig,
      lateDeliveryConfigs,
    } = this.state;
    const secondaryPaymentId = this.getSecondaryPaymentMethod()?.id;

    const extraFields = fromUnpaid ? { edit_order: true } : {};

    const orderObj = Array.isArray(order) ? order[0] : order;
    const amount = Number(customPaymentAmount || 0);

    const paymentBody = [
      {
        amount,
        account_id: customerId,
        payment_method_id: activeTab,
      },
    ];

    secondPaymentEnabled &&
      paymentBody.push({
        account_id: customerId,
        payment_method_id: String(secondaryPaymentId),
        amount: Number(
          (remainBalance - Number(customPaymentAmount)).toFixed(2)
        ),
      });
    let transKey = "golden_points_order_transactions_attributes";

    const headers = await this.getHeaders();
    const orderData: any = this.props.order;
    const orderId = Array.isArray(orderData) ? orderData[0]?.id : orderData?.id;

    const jsonBody = JSON.stringify({
      data: {
        ...extraFields,
        id: orderId ?? 0,
        [transKey]: paymentBody.filter((item) => item.amount >= 0),
          ...(activeTab === 7
        ? { mokkafa_otp: otp || "" }
        : { otp: otp || "" }),
      },
    });

    const message = makeApiMessage({
      method: "PUT",
      body: jsonBody,
      headers: headers,
      url: configJSON.addPaymentTransactionEndPoint,
    });

    this.makePaymentCallId = message.messageId;

    runEngine.sendMessage(message.id, message);
  };

  getWalletVerificationParams = (): { payment_type: string; amount: number } | null => {
    const {
      remainBalance,
      activeTab,
    } = this.state;

    const amount = Number(remainBalance) || 0;

    const paymentTypeMap: Record<number, string> = {
      1: "cash",
      2: "credit_card",
      6: "qitaf",
      7: "mokafaa",
    };

    const paymentType = paymentTypeMap[Number(activeTab)] || "regular";

    return {
      payment_type: paymentType,
      amount: Number(amount.toFixed(2)),
    };
  };

  requiresWalletVerification = (): boolean => {
    return this.getWalletVerificationParams() !== null;
  };

   openWalletVerification = () => {
    const params = this.getWalletVerificationParams();
    if (!params) return;
    this.setState({
      walletVerifyOpen: true,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyMaskedPhone: "",
      walletVerifyExpiresAt: "",
      walletVerifyOtpSent: false,
      walletVerifyError: "",
      walletVerifyWalletType: params.payment_type,
      walletVerifyAmount: params.amount,
      walletVerified: false,
      loading: false,
      isPayButtonClicked: false,
    });
    if (!this.resolveCustomerPhone() && this.props.order?.id) {
      this.getOrderDetails();
    }
  };

    getOrderDetails = () => {
      const store_management_id = localStorage.getItem("store_id");
      const { customerId } = this.props;
      const message = makeApiMessage({
        url: `${configJSON.getOrderDetailsApi}/${this.props.order?.id || 0}`,
        method: "GET",
      });
      this.getOrderDetailsCallId = message.messageId;
      runEngine.sendMessage(message.id, message);
    };

      async verifyWallet() {
        const { walletVerifyChannel, walletVerifyOtpCode, walletVerifyToken } =
          this.state;
        const order = this.props.order;
    
        let body: { token?: string; phone_number?: string; otp_code?: string };
        if (walletVerifyChannel === "qr") {
          if (!walletVerifyToken.trim()) {
            this.setState({ walletVerifyError: "Please enter the QR token." });
            return;
          }
          body = { token: walletVerifyToken.trim() };
        } else if (walletVerifyChannel === "otp") {
          if (walletVerifyOtpCode.length !== 4) {
            this.setState({ walletVerifyError: "Enter the 4-digit OTP." });
            return;
          }
          const phone = this.resolveCustomerPhone();
          if (!phone) {
            this.setState({ walletVerifyError: "Missing customer phone." });
            return;
          }
          const normalizedPhone = String(phone).startsWith("+")
            ? String(phone)
            : `+${phone}`;
          body = { phone_number: normalizedPhone, otp_code: walletVerifyOtpCode };
        } else {
          return;
        }
    
        this.setState({ walletVerifyVerifying: true, walletVerifyError: "" });
    
        const headers = await this.getHeaders();
        const message = makeApiMessage({
          method: "POST",
          url: configJSON.walletVerificationVerifyEndpoint,
          headers: headers,
          body: JSON.stringify(body),
        });
    
        this.verifyWalletCallId = message.messageId;
        runEngine.sendMessage(message.id, message);
      }

    
  async sendWalletVerifyOtp() {
        const phone = this.resolveCustomerPhone();
        const orderData: any = this.props.order;
        const orderId = Array.isArray(orderData) ? orderData[0]?.id : orderData?.id;


        const walletType = this.state.walletVerifyWalletType;
        const amount = this.state.walletVerifyAmount;

        if (!orderId) {
          this.setState({ walletVerifyError: "Missing order id." });
          return;
        }
    
        if (!walletType || ( !(amount > 0))) {
          this.setState({ walletVerifyError: "Missing wallet info." });
          return;
        }
        if (!phone) {
          this.setState({
            walletVerifyError:
              "Customer phone number not available. Reopen the order or refresh.",
          });
          this.getOrderDetails();
          return;
        }
    
        const normalizedPhone = String(phone).startsWith("+")
          ? String(phone)
          : `+${phone}`;
    
        this.setState({ walletVerifySending: true, walletVerifyError: "" });
    
        const headers = await this.getHeaders();
        const message = makeApiMessage({
          method: "POST",
          url: configJSON.walletVerificationOtpEndpoint,
          headers: headers,
          body: JSON.stringify({
            phone_number: normalizedPhone,
            order_id: orderId,
            payment_type: walletType,
            amount: amount,
          }),
        });
    
        this.sendWalletVerifyOtpCallId = message.messageId;
        runEngine.sendMessage(message.id, message);
  }

  resolveCustomerPhone = (): string => {
    const propsOrder: any = this.props.order || {};
    const order = Array.isArray(propsOrder) ? propsOrder[0] : propsOrder;
    const candidates = [
      order?.account?.full_phone_number,
      order?.account?.phone_number?.toString(),
      order?.full_phone_number,
      order?.phone_number?.toString(),
    ];
    const found = candidates.find(
      (value) => typeof value === "string" && value.length > 0
    );
    return found ? String(found) : "";
  };

  closeWalletVerification = () => {
    this.setState({
      walletVerifyOpen: false,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifySending: false,
      walletVerifyVerifying: false,
      walletVerifyOtpSent: false,
      walletVerifyError: "",
    });
  };

  selectWalletVerifyChannel = (channel: "qr" | "otp") => {
    this.setState({
      walletVerifyChannel: channel,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyOtpSent: false,
      walletVerifyError: "",
    });
  };

  setWalletVerifyOtpCode = (otp: string) => {
    const cleaned = otp.replace(/\D/g, "").slice(0, 4);
    this.setState({ walletVerifyOtpCode: cleaned, walletVerifyError: "" });
  };

  setWalletVerifyToken = (token: string) => {
    this.setState({ walletVerifyToken: token, walletVerifyError: "" });
  };


  getSecondaryPaymentMethod() {
    const { selectedSecondPaymentMethod, paymentMethods } = this.state;
    return paymentMethods.find(
      (item: IPaymentMethod) => item.name === selectedSecondPaymentMethod
    );
  }

  getPrimaryPaymentMethod() {
    const { activeTab, paymentMethods } = this.state;
    return paymentMethods.find(
      (paymentMethod) => paymentMethod.id === activeTab
    );
  }

  getPaymentMethodId(keyName: string) {
    const cashPayment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase() === keyName
    );
    return cashPayment ? cashPayment.id : 0;
  }

  getCashPaymentId = () => {
    const cashPayment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase().trim() === "cash"
    );
    return cashPayment ? cashPayment.id : 0;
  };

  getPayLaterPaymentId = () => {
    const payment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase().trim() === "pay later"
    );
    return payment ? payment.id : 0;
  };

  getWalletPaymentId = () => {
    const cashPayment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase().trim() === "wallet"
    );
    return cashPayment ? cashPayment.id : 0;
  };

  async componentDidMount() {
    this.handleGetPaymentMethods();
    this.getRemainBalance();
    this.getRewards();
  }

  handleGetPaymentMethods = () => {
    let data = localStorage.getItem("payment_method_lists");

    if (data) {
      this.setState({ paymentMethods: JSON.parse(data) }, () =>
        this.handleAfterPaymentMethod()
      );
    } else {
      this.getPaymentMethods();
    }
  };

  handlePayAll = () => {
    if (this.state.activeTab === this.getWalletPaymentId()) {
      if (this.state.walletBalance < this.state.remainBalance) {
        this.setState({
          errorMessage: configJSON.label_notSufficientWalletBalance,
          errorSnackbarOpen: true,
        });
        return;
      }
    }
    this.setState({
      customPaymentAmount: this.state.remainBalance + "",
    });
  };

  checkForBalance = (prevProps: Props) => {
    if (
      this.props.order !== prevProps.order &&
      this.props.order &&
      this.props.order.id &&
      this.props.open
    ) {
      this.getRemainBalance();
    }
  };

  checkForTabChange = (prevProps: Props, prevState: S) => {
    const { activeTab } = this.state;
    if (activeTab !== prevState.activeTab) {
      this.setState({
        showOtpScreen: false,
        customPaymentAmount: this.state.remainBalance + "",
      });
    }
  };

  async componentDidUpdate(prevProps: Props, prevState: S) {
    if (
      this.props.order &&
      this.props.order.status === "placed" &&
      !this.props.fromUnpaid
    )
      return;
    if (
      prevProps.customerId !== this.props.customerId &&
      Number(this.props.customerId) &&
      this.props.open
    ) {
      this.getRewards();
      this.setState({
        isRedeemAllPoints: false,
        isUsed: false,
      });
    }
    if (
      this.state.remainBalance !== prevState.remainBalance ||
      this.state.walletBalance !== prevState.walletBalance ||
      this.state.customPaymentAmount !== prevState.customPaymentAmount
    ) {
      this.setState({
        secondPaymentEnabled:
          Number(this.state.customPaymentAmount) < this.state.remainBalance,
      });
    }
    if (
      Number(this.state.customPaymentAmount) > this.state.walletBalance &&
      this.state.activeTab === this.getWalletPaymentId()
    ) {
      this.setState({
        customPaymentAmount: this.state.walletBalance + "",
      });
    }

    if (
      this.props.order &&
      this.props.open !== prevProps.open &&
      this.props.open
    ) {
      this.getRemainBalance();
      this.setState({
        activeTab: this.getCashPaymentId(),
        showOtpScreen: false,
        skipRedeemPoints: false,
      });
    }

    this.checkForTabChange(prevProps, prevState);
    this.checkForBalance(prevProps);
  }

  useAmount = () => {
    this.setState({
      isUsed: true,
    });
  };

  onOtpSuccess = () => {
    this.makePayment("", {});
  };

  handlePay() {
    const {
      points,
      skipRedeemPoints,
      secondPaymentEnabled,
      selectedSecondPaymentMethod,
    } = this.state;
    const { name } = (this.getPrimaryPaymentMethod() as IPaymentMethod) || {};
    const { name: secondName } =
      (this.getSecondaryPaymentMethod() as IPaymentMethod) || {};

    // if (name === "Wallets") {
    //   const condition = points > 0 && !skipRedeemPoints;
    //   if (condition) {
    //     this.setState({ skipRedeemPoints: true });
    //   }
    // }

    if (secondPaymentEnabled && !selectedSecondPaymentMethod) {
      this.setState({
        errorMessage: "Please select second payment method",
        errorSnackbarOpen: true,
      });
      return;
    }

    const isQitaf = [name, secondName].includes("Qitaf");
    const isMokafaa = [name, secondName].includes("Mokafaa");

    if (!(isQitaf || isMokafaa)) {
      if (this.requiresWalletVerification() && !this.state.walletVerified) {
        this.openWalletVerification();
        return;
      }
    }
    this.setState({ loading: true });

    if ((isQitaf || isMokafaa) && !this.state.isQitafOtpComplete) {
      this.sendOtp(isQitaf, isMokafaa);
    } else {
      this.makePayment("", {});
    }
   
  }


  async sendOtp(isQitaf: boolean, isMokafaa: boolean) {
    const apiUrl = configJSON.verifyOtpApi;

    const orderData: any = this.props.order;

    const orderId = Array.isArray(orderData)
      ? orderData[0]?.id
      : orderData?.id;

    const {
      activeTab,
      secondPaymentEnabled,
      selectedSecondPaymentMethod,
      paymentMethods,
    } = this.state;

    const paymentMethodIds: number[] = [Number(activeTab)];

    const secondPaymentMethod = paymentMethods.find(
      (item: IPaymentMethod) =>
        item.name === selectedSecondPaymentMethod
    );

    if (
      secondPaymentEnabled &&
      secondPaymentMethod?.id &&
      !paymentMethodIds.includes(Number(secondPaymentMethod.id))
    ) {
      paymentMethodIds.push(Number(secondPaymentMethod.id));
    }

    const payload: any = {
      id: orderId || 0,
      is_golden_point: true,
      payment_method_ids: paymentMethodIds,
    };

    if (isQitaf) {
      payload.is_qitaf = true;
    }

    if (isMokafaa) {
      payload.is_mokkafa = true;
    }

    const headers = await this.getHeaders();

    const message = makeApiMessage({
      body: JSON.stringify(payload),
      headers: headers,
      method: "POST",
      url: apiUrl,
    });

    this.sendOtpCallId = message.messageId;

    runEngine.sendMessage(message.id, message);
  }
  
  handleSnackbarClose = () => {
    this.setState({
      errorSnackbarOpen: false,
    });
  };

  handleSuccessSnackbarClose = () => {
    this.setState({
      successMessage: "",
    });
  };

  handleOtpError = (message: string) => {
    this.setState({
      errorMessage: message,
      errorSnackbarOpen: true,
    });
  };

  handleClose = () => {
    this.setState({
      showOtpScreen: false,
      selectedSecondPaymentMethod: "",
    });
    this.props.handleClose();
  };

  receiveOtpMessage = (responseJson: { message: string; errors: string }) => {
    if (responseJson.message) {
      this.setState({
        showOtpScreen: true,
      });
    } else if (responseJson.errors) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson.errors,
      });
    }
  };

  receivePaymentMethods = (responseJson: { data: IPaymentMethod[] }) => {
    // const responseJson = message.getData();

    const filteredMethods = (responseJson.data || []).filter(
      (method: any) =>
        method.name.toLowerCase() !== "wallet" &&
        method.name.toLowerCase() !== "pay later"
    );
    this.setState(
      {
        paymentMethods: filteredMethods,
      },
      () => this.handleAfterPaymentMethod()
    );
  };

  handleAfterPaymentMethod = () => {
    if (this.props.order) {
      this.setState({
        activeTab: this.getCashPaymentId(),
      });
    }
  };

  receiveRewardCall = (responseJson: {
    total_amount: string;
    points: number;
    currency: string;
  }) => {
    if (responseJson) {
      this.setState({
        totalAmount: responseJson.total_amount || "0",
        points: responseJson.points || 0,
        currency: responseJson.currency || "SAR",
      });
    }
  };

  receiveRedeemAllPoints = (responseJson: {
    errors: string;
    wallet_balance: number;
  }) => {
    if (responseJson.errors) {
      this.setState({
        errorMessage: responseJson.errors,
        errorSnackbarOpen: true,
      });
    } else {
      this.setState(
        {
          isRedeemAllPoints: true,
          walletBalance: Number(responseJson.wallet_balance),
        },
        this.getRemainBalance
      );
    }
  };

  receiveRemainBalance = (responseJson: {
    payable_balance: number | string;
    default_payment_method_type: string;
  }) => {
    let resData = responseJson.default_payment_method_type;
    let data = localStorage.getItem("payment_method_lists");
    if (data) {
      let paymentMethodList = JSON.parse(data);
      let matchedMethod = paymentMethodList.find(
        (method: any) => method.payment_type === resData
      );

      if (matchedMethod) {
        this.setState({ activeTab: matchedMethod.id });
      }
    }
    this.setState({
      paymentMathod: responseJson?.default_payment_method_type,
      remainBalance: responseJson.payable_balance as number,
      customPaymentAmount: responseJson.payable_balance + "",
      isRemainingBalanceLoading: false,
    });
    if (
      responseJson.payable_balance === 0 &&
      this.props.order &&
      (this.state.activeTab === this.getPayLaterPaymentId()
        ? this.props.order.status === "placed"
        : Number(this.props.order.total))
    )
      this.props.onPaymentDone();
  };

  receiveMakePayment = (responseJson: {
    status: number;
    errors: string;
    order_status: string;
    message: string;
    order?: {
      data: PaymentTransactionData[];
    };
  }) => {
    if (String(responseJson.status) === "placed") {
      this.props.onPaymentDone(responseJson?.order?.data || []);
    }

    if (responseJson?.status == 422) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson?.errors,
      });
    } else {
      this.setState({
        successMessage: responseJson.message,
      });
    }

    this.setState({ isPayButtonClicked: false });

    setTimeout(() => {
      this.setState({
        selectedSecondPaymentMethod: "",
      });
    }, 1000);
  };

  receiveVerifyWallet = (responseJson: any) => {
    if (responseJson?.meta?.verified) {
      this.setState(
        {
          walletVerifyVerifying: false,
          walletVerified: true,
          walletVerifyOpen: false,
          walletVerifyChannel: null,
          walletVerifyOtpCode: "",
          walletVerifyToken: "",
          walletVerifyOtpSent: false,
          walletVerifyError: "",
          loading: true,
          isPayButtonClicked: true,
        },
        () => {
          this.makePayment("", {});
        }
      );
    } else {
      const errorMessage =
        responseJson?.errors?.[0] ||
        responseJson?.error ||
        responseJson?.message ||
        "Invalid or expired verification.";
      this.setState({
        walletVerifyVerifying: false,
        walletVerifyError:
          typeof errorMessage === "string"
            ? errorMessage
            : "Invalid or expired verification.",
      });
    }
  };

  receiveSendWalletVerifyOtp = (responseJson: any) => {
    if (responseJson?.data?.verification_id) {
      this.setState({
        walletVerifySending: false,
        walletVerifyOtpSent: true,
        walletVerifyMaskedPhone: responseJson.data.masked_phone_number || "",
        walletVerifyExpiresAt: responseJson.data.expires_at || "",
        walletVerifyError: "",
      });
    } else {
      const errorMessage =
        responseJson?.errors?.[0] ||
        responseJson?.error ||
        responseJson?.message ||
        "Failed to send OTP.";
      this.setState({
        walletVerifySending: false,
        walletVerifyError:
          typeof errorMessage === "string"
            ? errorMessage
            : "Failed to send OTP.",
      });
    }
  };

  async receive(from: string, message: Message) {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId === this.getRewardsCallId) {
        this.receiveRewardCall(responseJson);
      } else if (apiRequestCallId === this.getPaymentMethodsCallId) {
        this.receivePaymentMethods(responseJson);
      } else if (apiRequestCallId === this.getRemainBalanceCallId) {
        this.receiveRemainBalance(responseJson);
      } else if (apiRequestCallId === this.makePaymentCallId) {
        this.receiveMakePayment(responseJson);
      } else if (apiRequestCallId === this.sendOtpCallId) {
        this.receiveOtpMessage(responseJson);
      } else if (apiRequestCallId === this.verifyWalletCallId) {
        this.receiveVerifyWallet(responseJson);
        return;
      }else if (apiRequestCallId === this.sendWalletVerifyOtpCallId) {
        this.receiveSendWalletVerifyOtp(responseJson);
        return;
      }
      this.setState({ loading: false });
    }
  }

  onChangeTab(keyID: string | number, name: string) {
    this.setState({ activeTab: keyID, paymentMathod: name });
  }

  onSelectSecondPayments(keyID: string) {
    this.setState({ selectedSecondPaymentMethod: keyID });
  }

  onChangeAmountToPay(
    activeTab: number | string,
    originalValue: number,
    walletBalance: number,
    remainBalance: number
  ) {
    let value = "" + originalValue;
    if (Number(originalValue) > remainBalance) {
      value = remainBalance + "";
    }
    this.setState({ customPaymentAmount: value });
  }

  onKeyPressInput(keyID: string, preventDefault: Function, prevented: boolean) {
    if (
      !(
        (keyID >= "0" && keyID <= "9") ||
        keyID === "." ||
        keyID === "Backspace"
      )
    ) {
      !prevented && preventDefault && preventDefault();
    }
  }

  // Customizable Area End
}
